import '@common/ExtensionsJS';
import Vue from 'vue';
import '@src/db.js'; // Precisa ser antes do import do store
import '@src/plugins/axios';
import App from '@src/App.vue';
import './registerServiceWorker';
import router from '@src/router';
import store from '@src/store';
import vuetify from './plugins/vuetify';

// import "roboto-fontface/css/roboto/roboto-fontface.css";
// import "roboto-fontface/css/roboto/sass/roboto-fontface-regular.scss";
// import '@fortawesome/fontawesome-free/css/all.css';
// import "@mdi/font/css/materialdesignicons.css";
import '@src/design/fonts/roboto-fontface.scss';
import '@src/design/fonts/materialdesignicons.scss';
import '@src/design/fonts/awesome-free.scss';

import i18n from '@src/plugins/i18n';
import pluginGlobal from '@src/plugins/global.js';
import '@src/plugins/vuefire';
import VueTheMask from 'vue-the-mask';
import '@components/_globals';
import money from 'v-money';
import * as Chart from 'vue-google-charts/legacy';
import * as VueGoogleMaps from 'gmap-vue';
import {config} from '@src/config';
import moment from 'moment';
import VueSweetalert2 from 'vue-sweetalert2';
// If you don't need the styles, do not connect
// import 'sweetalert2/dist/sweetalert2.min.css';
import '@src/design/sweetalert2Theme.scss';
import {apolloClient} from '@src/network/apollo/apolloClient';
import VueApollo from 'vue-apollo';

import * as FinancialRepositoryGQL from '@repositories/FinancialRepositoryGQL';
import {TransactionEntity} from '@entities/TransactionEntity';
import * as EventUtils from '@common/EventUtils';
import PrimeVue from 'primevue/config';
import {initFcmGlobal} from '@src/fcmGlobal';
// import Tooltip from 'primevue/tooltip'; // New, with primevue
import Tooltip from 'vue-directive-tooltip'; // Old
// import InputText from 'primevue/inputtext';
import {AxRegIntegrationClass} from '@utils/IntegrationAxReg';
import fcmReactiveBindPlugin from '@src/plugins/fcmReactiveBind';

Vue.use(PrimeVue, {ripple: true});
// Vue.directive('tooltip', Tooltip); // New, with primevue
Vue.use(Tooltip); // Old

// Registrar componentes global
// Vue.component('InputText', InputText);


Vue.use(VueApollo);

EventUtils.initClient(FinancialRepositoryGQL, TransactionEntity);

const _ = require('lodash');


const fcmI18n = require('@i18n');

Vue.use(pluginGlobal);

Vue.use(VueTheMask);
Vue.use(money);
Vue.use(Chart);
Vue.use(fcmReactiveBindPlugin);


Vue.use(VueGoogleMaps, {
  load: {
    key: config.maps.key,
    libraries: 'places', // This is required if you use the Autocomplete plugin
    // OR: libraries: 'places,drawing'
    // OR: libraries: 'places,drawing,visualization'
    // (as you require)

    //// If you want to set the version, you can do so:
    // v: '3.26',
  },

  //// If you intend to programmatically custom event listener code
  //// (e.g. `this.$refs.gmap.$on('zoom_changed', someFunc)`)
  //// instead of going through Vue templates (e.g. `<GmapMap @zoom_changed="someFunc">`)
  //// you might need to turn this on.
  // autobindAllEvents: false,

  //// If you want to manually install components, e.g.
  //// import {GmapMarker} from 'gmap-vue/src/components/marker'
  //// Vue.component('GmapMarker', GmapMarker)
  //// then set installComponents to 'false'.
  //// If you want to automatically install all the components this property must be set to 'true':
  installComponents: true
});

Vue.use(VueSweetalert2);

Vue.config.productionTip = false;

require('moment/locale/pt-br');
window.moment = moment;
window._ = _;
if (process.env.NODE_ENV !== 'production') {
  window.jwDebug ||= {};
  // Usar o firestore.colection('blablabla').where(....).fcmGenerator()
  //   window.jwDebug.firebaseGenerator = require('@common/firebaseGenerator');
  window.jwDebug.EventUtils = require('@common/EventUtils');
  window.jwDebug.StringUtils = require('@common/StringUtils');
  window.jwDebug.GeoUtils = require('@common/GeoUtils');
  window.jwDebug.NumberUtils = require('@common/NumberUtils');
  window.jwDebug.ObjectUtils = require('@common/ObjectUtils');
  window.jwDebug.ImageUtils = require('@common/ImageUtils');
  window.jwDebug.TimeUtils = require('@common/TimeUtils');
  window.jwDebug.Procedures = require('@src/services/Procedures');
  window.jwDebug.status = require('@common/status');
  window.jwDebug.FinancialRepository = require('@repositories/FinancialRepository');
  window.jwDebug.FinancialRepositoryGQL = require('@repositories/FinancialRepositoryGQL');
  window.jwDebug.TransactionEntity = require('@entities/TransactionEntity').TransactionEntity;
  window.jwDebug.PaymentEntity = require('@entities/PaymentEntity').PaymentEntity;
  window.jwDebug.PaymentSplittedEntity = require('@entities/PaymentSplittedEntity').PaymentSplittedEntity;
  window.jwDebug.ListModel = require('@common/model/ListModels');
  window.jwDebug.FcmModel = require('@common/model/FcmModel');
  window.jwDebug.UserEntity = require('@entities/UserEntity').UserEntity;
  window.jwDebug.CompanyUserEntity = require('@entities/CompanyUserEntity').CompanyUserEntity;
  window.jwDebug.FcmConverter = require('@src/libs/parallelUniverse/FcmConverter');
  window.jwDebug.ScheduleGQL = require('@repositories/ScheduleGQL');
  window.jwDebug.ChargeEntity = require('@entities/ChargeEntity').ChargeEntity;
  window.jwDebug.ChargeNegotiationEntity = require('@entities/ChargeNegotiationEntity').ChargeNegotiationEntity;
  window.jwDebug.EventEntity = require('@entities/EventEntity').EventEntity;
  window.jwDebug.BaseEntity = require('@entities/BaseEntity').BaseEntity;
  window.jwDebug.PatientEntity = require('@entities/PatientEntity').PatientEntity;
  window.jwDebug.FinancialItemEntity = require('@entities/FinancialItemEntity').FinancialItemEntity;
  window.jwDebug.getBaseRepository = require('@src/repositories/BaseRepository').getBaseRepository;
  window.jwDebug.UserRepository = require('@src/repositories/UserRepository').getUserRepository();
  window.jwDebug.BankReconciliationMatchingService = require('@services/BankReconciliationMatchingService');


  // import {texto2 as forma1} from '/functions/common/test';
  // import forma2 from '/functions/common/test';
  // import * as forma3 from '/functions/common/test';
  // const forma4 = require('/functions/common/test');
  // console.log('Super teste', forma1);
  // console.log('Super forma2', forma2.texto2);
  // console.log('Super forma3', forma3.texto2);
  // console.log('Super forma3_', forma4.teste());
}

/*
// Reseta os Services workers se houver algum problema com a atualização dos mesmos
if(window.navigator && navigator.serviceWorker) {
  navigator.serviceWorker.getRegistrations()
    .then(function(registrations) {
      for(let registration of registrations) {
        registration.unregister();
      }
    });
}
 */



const apolloProvider = new VueApollo({
  defaultClient: apolloClient,
});

Vue.prototype.$AxRegIntegration = new AxRegIntegrationClass();
export const app = new Vue({
  router,
  store,
  vuetify,
  i18n,
  apolloProvider,
  beforeMount(...args) {
    const locale = this.$i18n.locale;
    if (fcmI18n.languages[locale]) {
      this.$vuetify.lang.current = fcmI18n.languages[locale].vuetify;
    }
    initFcmGlobal(this);
  },
  apollo: {
    // Apollo specific options
  },
  render: h => h(App)
}).$mount('#app');



if (window) {
  window.vueApp = app;
}

if (module.hot) {
  module.hot.accept(['@i18n/pt-BR'], function() {
    i18n.setLocaleMessage('pt-BR', require('@i18n/pt-BR').default);
    // Or the following hot updates via $i18n property
    // app.$i18n.setLocaleMessage('en', require('./en').default)
    // app.$i18n.setLocaleMessage('ja', require('./ja').default)
  });
}


/*

router.beforeEach((to, from, next) => {
  let currentUser = auth().currentUser
  let requiresAuth = to.matched.some(record => record.meta.requiresAuth)

  if (requiresAuth && !currentUser) {
    next('Login')
  } else if (!requiresAuth && currentUser) {
    next()
  } else {
    next()
  }
})

let app

// Initialize the app after Firebase has iniitalized
auth().onAuthStateChanged(function (user) {
  if (!app) {
    app = new Vue({
      el: '#app',
      router,
      render: h => h(App)
    })
  }
})

*/

/*

let performance = null
// TODO FCM register bugs only on production
if (
  process.env.NODE_ENV === 'production' &&
  process.env.NODE_ENV !== 'production'
) {
  Vue.config.errorHandler = function (err, vm, info) {
    // Toast.error(error.message)
    console.warn('errorHandler', err.message)
    // send error as event to google analytcs...
    if (err) {
      console.warn('errorHandler stack', err.stack)
      console.warn('errorHandler info', info)
    }
  }

  window.onerror = function (msg, url, lineNo, columnNo, error) {
    // maybe we need to also catch errors here and send to GA
    console.warn('onerror', msg, url, lineNo, columnNo, error)
  }
}

performance = firebase.performance()
Vue.mixin({
  methods: {
    $performance: function () {
      return performance
    },
  },
})

 */
